export default {
  name: 'Editor',
  path: '/',
  meta: {
    title: '视频编辑器'
  }
};
